// extracted by mini-css-extract-plugin
export default {"tooltip":"Vn-z","sharingV2":"Wn-z","sharingIconsV2":"Xn-z","links":"Yn-z","link":"Zn-z","facebookV2":"_n-z","twitterV2":"ao-z","pinterestV2":"bo-z"};